import useQueryParameters from 'utils/hooks/routes/useQueryParameters'

export const gameDialogKey = 'game-dialog'

export default function useGameDialog() {
  const [gameDialog, changeGameDialog] = useQueryParameters<string>(gameDialogKey)

  return { gameDialog, changeGameDialog }
}
